const ORGANIZATION_TYPE_OPTIONS = [
   {
      value: 0,
      label: 'All',
      id: 0,
      name: 'All',
   }, {
      value: 3,
      label: 'Enterprise',
      id: 3,
      name: 'Enterprise',
   }, {
      value: 2,
      label: 'Free',
      id: 2,
      name: 'Free',
   }, {
      value: 1,
      label: 'Subscription',
      id: 1,
      name: 'Subscription',
   },
];

export default ORGANIZATION_TYPE_OPTIONS;
